// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__34AwD","list":"PatternAutocomplete_list__2x5Nh"};